<template>
  <div class="saas-page-content-youtube">
    <div class="saas-page-content-youtube__inner">
      <div class="saas-page-content-youtube__content">
        <h2 class="saas-page-content-youtube__title">
          {{ block.title }}
        </h2>
        <div
          class="saas-page-content-youtube__description"
          v-html="block.text"
        ></div>
        <div
          v-if="block.buttons.length > 0"
          class="saas-page-content-youtube__actions"
        >
          <CmsLink
            v-for="button in block.buttons"
            :key="button.id"
            :url-or-path="button.url_or_path"
            :class="`button button--${button.type} button--large`"
          >
            {{ button.text }}
          </CmsLink>
        </div>
      </div>
      <div class="saas-page-content-youtube__video">
        <iframe
          class="saas-page-content-youtube__video-iframe"
          width="644"
          height="456"
          :src="`https://www.youtube.com/embed/${block.youtube_id}`"
          title=""
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import CmsLink from '@saas/components/cms/CmsLink'

export default {
  name: 'PageBlockHorizontalContentYoutube',
  components: { CmsLink },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
}
</script>
